export default __webpack_public_path__ + "static/media/Group 1674.26c59451.svg";